import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelper, { CURRENCY_RATIO, currencyIsoCodes } from '../../../general/js/basket/currency-helper';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import {
    PRODUCT_TAG_SCORERS_PREMIUM,
    PRODUCT_TAG_ENGRAVERS,
    PRODUCT_TAG_CAR,
    PRODUCT_TAG_MOTORCYCLE,
    PRODUCT_TAG_COACH,
    PRODUCT_TAG_MINIBUS,
    HOSPITALITY_PRODUCTS
} from '../../../general/js/basket/constants';

export default class BasketProduct extends React.Component {
    constructor(props) {
        super(props);

        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.carProductsArray = [PRODUCT_TAG_CAR, PRODUCT_TAG_MOTORCYCLE, PRODUCT_TAG_COACH, PRODUCT_TAG_MINIBUS];
    }

    onQuantityChange(e) {
        let quantity = parseInt(e.target.value, 10);
        quantity = !Number.isNaN(quantity) ? quantity : 0;

        const product = this.props.product;
        const oldQuantity = product.quantity;

        let eventType = '';
        let quantityDelta = 0;

        if (quantity > oldQuantity) {
            eventType = ecommerceEventTypes.ADD_TO_CART;
            quantityDelta = quantity - oldQuantity;
        } else if (quantity < oldQuantity) {
            eventType = ecommerceEventTypes.REMOVE_FROM_CART;
            quantityDelta = oldQuantity - quantity;
        }

        const productGroupYear = this.props.productGroup.title.split(' ')[3];
        const productPrice = product.price / CURRENCY_RATIO;

        gtm.pushEcommerceEvent(eventType, {
            currency: currencyIsoCodes.GBP,
            value: productPrice * quantityDelta,
            items: [
                {
                    item_id: product.productId,
                    item_name: `${product.title} ${productGroupYear}`,
                    price: productPrice,
                    quantity: quantityDelta
                }
            ]
        });

        this.props.onQuantityUpdate(quantity);
    }

    onRemoveClick() {
        const product = this.props.product;
        const productPrice = product.price / CURRENCY_RATIO;
        const productGroupYear = this.props.productGroup.title.split(' ')[3];

        gtm.pushEcommerceEvent(ecommerceEventTypes.REMOVE_FROM_CART, {
            currency: currencyIsoCodes.GBP,
            value: productPrice * product.quantity,
            items: [
                {
                    item_id: product.productId,
                    item_name: `${product.title} ${productGroupYear}`,
                    price: productPrice,
                    quantity: product.quantity
                }
            ]
        });

        this.props.onQuantityUpdate(0);
    }

    getProductQuantities(product) {
        const result = [];
        let startQuantity = 1;

        if (product.tag === PRODUCT_TAG_ENGRAVERS) {
            startQuantity = 2;
        }

        const hospitalityProduct = HOSPITALITY_PRODUCTS[product.tag];

        if (hospitalityProduct !== undefined) {
            if (hospitalityProduct.quantityMultiplier % 2 === 0) {
                startQuantity = 2;
            }
        }

        for (let i = startQuantity; i <= product.maxQuantity; i += startQuantity) {
            result.push(i);
        }

        return result;
    }

    renderControl(product, hasBallotConfiguration) {
        return (
            !hasBallotConfiguration ?
                product.tag === PRODUCT_TAG_SCORERS_PREMIUM ?
                    <select
                        className="basket-product__quantity-control" value={product.quantity}
                        onChange={this.onQuantityChange}
                        aria-label={`${product.title}, select product quantity`}
                    >
                        {
                            <option
                                key={product.quantity}
                                disabled
                                value={product.quantity}>{product.quantity}</option>
                        }
                    </select>
                    :
                    <select
                        className="basket-product__quantity-control" value={product.quantity}
                        onChange={this.onQuantityChange}
                        aria-label={`${product.title}, select product quantity`}
                    >
                        {
                            this.getProductQuantities(product).map((quantity) =>
                                <option
                                    key={quantity}
                                    disabled={quantity > product.maxAvailable}
                                    value={quantity}>{quantity}</option>)
                        }
                    </select>

                :
                (this.carProductsArray.indexOf(product.tag) > -1) ?
                    this.props.groupHasMoreTypesOfProducts ?
                        <div className="basket-product__quantity-display">
                            {product.quantity}
                        </div>
                        :
                        <select
                            className="basket-product__quantity-control" value={product.quantity}
                            onChange={this.onQuantityChange}
                            aria-label={`${product.title}, select product quantity`}
                        >
                            {
                                this.getProductQuantities(product).map((quantity) =>
                                    <option
                                        key={quantity}
                                        disabled={quantity > product.maxAvailable}
                                        value={quantity}>{quantity}</option>)
                            }
                        </select>
                    :
                    <div className="basket-product__quantity-display">
                        {product.quantity}
                    </div>
        );
    }

    render() {
        const { product } = this.props;
        return (
            <div className="basket-product">
                <div className="basket-product__title">
                    {product.title}
                </div>
                <div className="basket-product__price">
                    {CurrencyHelper.convertToPounds(product.price)}
                </div>
                <div className="basket-product__quantity">
                    <span className="basket-product__quantity-label">Qty:</span>
                    {this.renderControl(product, this.props.hasBallotConfiguration)}
                    {!this.props.hasBallotConfiguration ?
                        <button
                            className="basket-product__remove-button"
                            type="button"
                            onClick={this.onRemoveClick}
                        >
                            <span className="visually-hidden">remove product from basket</span>
                            <svg className="icon" width="8" height="8" focusable="false">
                                <use xlinkHref="#icon-cross" />
                            </svg>
                        </button>
                        :
                        (this.carProductsArray.indexOf(product.tag) > -1) ?
                            this.props.groupHasMoreTypesOfProducts ?
                                <button className="basket-product__remove-button-hidden" />
                                :
                                <button
                                    className="basket-product__remove-button"
                                    type="button"
                                    onClick={this.onRemoveClick}
                                >
                                    <span className="visually-hidden">remove product from basket</span>
                                    <svg className="icon" width="8" height="8" focusable="false">
                                        <use xlinkHref="#icon-cross" />
                                    </svg>
                                </button>
                            :
                            <button className="basket-product__remove-button-hidden" />}
                </div>
                <div className="basket-product__sum">
                    {
                        product.price > 0 ?
                            CurrencyHelper.convertToPounds(product.sum) :
                            'Free'
                    }
                </div>
            </div>
        );
    }
}

BasketProduct.propTypes = {
    product: PropTypes.object.isRequired,
    productGroup: PropTypes.object.isRequired,
    onQuantityUpdate: PropTypes.func,
    hasBallotConfiguration: PropTypes.bool,
    groupHasMoreTypesOfProducts: PropTypes.bool
};
